<template>
  <div>
    <v-toolbar flat color="white">
      <v-btn id="customerAddButtonId" color="primary" dark class="mb-2" @click="newDialog=true" round>ADD CUSTOMER</v-btn>
      <v-btn @click="convertCustomersToOrg">1) Convert Customers</v-btn>
      <v-btn @click="updateIspSettings">2) Update ISP Settings</v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        id="searchId"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    </v-toolbar>

    <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">ADD CUSTOMER</h1>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  id="customerAddNameId"
                  v-model="editedItem.name"
                  label="Name*"
                  hint="What would you like to name this customer?"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field  v-model="editedItem.xeroCode" label="Xero Code"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field  v-model="editedItem.logo" label="Logo URL"></v-text-field>
              </v-flex>
                <v-flex xs12 sm6 md6>
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="Customer Type"
                  :items="customerType"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.customerTypeId"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                  <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                    :items="organisations"
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.customerOrganisationId"
                    label="Linked System Organisation"
                    >
               </v-autocomplete>
                </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-layout justify-center>
            <v-btn color="primary" round @click="close">Cancel</v-btn>
          <v-btn id="customerSaveAddButtonId" color="primary" round @click="saveNew">Save</v-btn>
          </v-layout>
          
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Edit Modal -->
    <v-dialog persistent v-model="dialog" max-width="750px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">EDIT CUSTOMER</h1>
      </v-toolbar>
      <v-toolbar flat color="white">
        <v-tabs>
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            @click="basicInformation=true;showContacts=false;ispTab=false;showDocuments=false"
            class="grey--text"
            flat
            round
            color="grey"
          >Basic Information</v-tab>
          <v-tab
            @click="basicInformation=false;showContacts=true;ispTab=false;showDocuments=false"
            class="grey--text"
            flat
            round
            color="grey"
          >Contacts</v-tab>
          <v-tab
            @click="basicInformation=false;showContacts=false;ispTab=false;showDocuments=true"
            class="grey--text"
            flat
            round
            color="grey"
          >Documents</v-tab>
           <v-tab
            v-if="this.ispFlag==true"
            @click="basicInformation=false;showContacts=false;ispTab=true;showDocuments=false"
            class="grey--text"
            flat
            round
            color="grey"
          >ISP Settings</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card flat>
        <v-card flat v-show="basicInformation">
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    id="customerEditNameId"
                    v-model="editedItem.name"
                    label="Name*"
                    hint="What would you like to name this customer?"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.xeroCode" label="Xero Code"></v-text-field>
                </v-flex>

                 <v-flex xs12 sm6 md6>
                <v-text-field v-model="editedItem.logo" label="Logo URL"></v-text-field>
              </v-flex>

                 <!-- <v-flex xs12 sm6 md6>
                <v-text-field prepend-icon="edit" v-model="editedItem.salesEmailAddress" label="Sales Email Address"></v-text-field>
              </v-flex> -->

              <!-- <v-flex xs12 sm6 md6>
                <v-text-field prepend-icon="edit" v-model="editedItem.termsConditionsLink" label="Terms & Conditions Link"></v-text-field>
              </v-flex> -->

               <v-flex xs12 sm6 md6>
                  <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                    :items="customerType"
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.customerTypeId"
                    label="Customer Type"
                    >
               </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                    :items="organisations"
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.customerOrganisationId"
                    label="Linked System Organisation"
                    >
               </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>

        
         <v-card flat v-show="ispTab">
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.regNo"
                    label="Registration Number"
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.vatNo"
                    label="Vat Number"
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                 <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.ispTermsConditionsLink"
                    label="Terms & Conditions Link"
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                 <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.fupUrl"
                    label="Fair Usage Policy URL"
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.applicationsEmailAddress"
                    label="Applications Email Address"
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                 <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.layer3Rate"
                    label="Layer 3 Rate"
                    type="number"
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                 <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.layer2Rate"
                    label="Layer 2 Rate"
                    type="number"
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                 <!-- <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.layer2Usage"
                    label="Layer 2 Usage"
                    type="number"
                    persistent-hint
                  ></v-text-field>
                </v-flex> -->

                 <!-- <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.layer2Percentage"
                    label="Layer 2 Percentage"
                    type="number"
                    persistent-hint
                  ></v-text-field>
                </v-flex> -->

                 <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.librePortId"
                    label="Libre Port ID"
                    type="number"
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                 <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.bankName"
                    label="Bank Name"
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                 <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.bankBranchCode"
                    label="Bank Branch Code"
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                 <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.bankAccountType"
                    label="Bank Account Type"
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                  <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.bankAccountNumber"
                    label="Bank Account Number"
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="customers"
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.billableCustomerId"
                    label="Billable Customer"
                    >
               </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm8 md8>
                  </v-flex>
                <v-flex xs12 sm6 md6>
                  <h3 class="text-xs-left grey--text">Primary Colour</h3>
                  <chrome-picker v-model="primaryColour" />
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <h3 class="text-xs-left grey--text">Secondary Colour</h3>
                  <chrome-picker v-model="secondaryColour" />
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
        <v-card flat v-show="showDocuments">
          <documentcomponent :customerid="editedItem.id" :documents="customerDocuments" @documentChange="fetchDocuments"></documentcomponent>
          </v-card>
        
        <v-card-actions>
          <v-layout justify-center>
          <v-btn color="primary" round @click="close">Cancel</v-btn>
          <v-btn id="customerSaveEditButtonId" color="primary" round @click="save">Save</v-btn>
          </v-layout>

          
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="associateContactDialog" max-width="750px">
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">CONTACT SEARCH RESULTS</h1>
        </v-toolbar>
        <v-data-table :headers="contactSearchHeaders" :items="contactResult" item-key="id">
          <template v-slot:items="props">
            <td class="text-xs-center">{{props.item.name}} {{props.item.surname}}</td>
            <td class="text-xs-center">{{props.item.permissions}}</td>
            <td class="text-xs-center">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                v-model="editedItem.contactTypeId"
                :items="contactTypes"
                item-text="name"
                item-value="id"
                >
               </v-autocomplete>
            </td>
          </template>
        </v-data-table>
        <v-flex v-show="errors.contact">
          <span class="red--text">{{errors.contact}}</span>
        </v-flex>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
          <v-btn
            color="blue darken-1"
            flat
            @click="linkContact(contactResult[0].id, editedItem.id, editedItem.contactTypeId)"
          >Associate Contact</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
    <v-dialog persistent v-model="assignContactType" max-width="750px">
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">ASSIGN A CONTACT TYPE</h1>
        </v-toolbar>
        <v-flex xs12 sm10 md10 px-3>
           <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                v-model="editedItem.contactTypeId"
                :items="contactTypes"
                label="Contact Type"
                item-text="name"
                item-value="id"
                 >
               </v-autocomplete>
        </v-flex>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="assignContactType=false">Cancel</v-btn>
          <v-btn
            color="primary"
            flat
            @click="linkContact(contactId, customerId, editedItem.contactTypeId);assignContactType=false;searchContacts=false "
          >Associate Contact</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="searchContacts" max-width="950px">
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">CONTACT SEARCH</h1>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-text-field v-model="contactSearch" label="Search"></v-text-field>
        </v-toolbar>
        <v-data-table :headers="fnoContactSearchHeaders" :search="contactSearch" :items="contactsList" item-key="id">
          <template v-slot:items="props">
            <v-btn
              flat
              color="primary"
              @click="assignContactType=true, contactId=props.item.id, customerId=editedItem.id"
            >
              <v-icon>add_circle_outline</v-icon>
            </v-btn>
            <td class="text-xs-center">{{props.item.name}}</td>
            <td class="text-xs-center">{{props.item.surname}}</td>
            <td class="text-xs-center">{{props.item.idNumber}}</td>
            <td class="text-xs-center">{{props.item.mobileNumber}}</td>
            <td class="text-xs-center">{{props.item.permissions}}</td>
          </template>
        </v-data-table>
        <v-flex v-show="errors.contact">
          <span class="red--text">{{errors.contact}}</span>
        </v-flex>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="close">Cancel</v-btn>
          </v-layout>
          
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

    <v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isLoading"
      :items="customers"
      :rows-per-page-items="[25, 50, 100, 250]"
      item-key="name"
      align-center
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
          <v-icon
            id="customerEditButtonId"
            small
            class="mr-2"
            @click="fetchContacts(props.item.id);editItem(props.item);basicInformation=true;showContacts=false;ispTab=false; ispFlag=false; checkIsp()"
          >edit</v-icon>
          <v-icon id="customerDeleteButtonId" small @click="deleteItem(props.item.id)">delete</v-icon>
        </td>
        <td class="text-xs-center">{{props.item.name}}</td>
        <td class="text-xs-center">{{props.item.xeroCode}}</td>
        <td
          v-if="props.item.customerType != null"
          class="text-xs-center"
        >{{props.item.customerType.name}}</td>
        <td v-if="props.item.customerType == null" class="text-xs-center">Not allocated</td>
        <!-- <td class="text-xs-center">{{props.item.salesEmailAddress}}</td> -->
        <td class="text-xs-center" v-if="props.item.isActive">
          <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->
    
    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
import Contacts from "@/components/ContactCard";
import { Chrome } from 'vue-color'
import DocumentUpload from '@/components/Documents.vue';
export default {
  components: {
    contacts: Contacts,
    'chrome-picker': Chrome,
    documentcomponent: DocumentUpload
  },
  data() {
    return {
      ispFlag: false,
      primaryColour: {r: 255, g: 0, b:0},
      secondaryColour: {r: 255, g: 0, b:0},
      ispTab: false,
      showDetails: true,
      contactSearch: "",
      loading: false,
      isLoading:true,
      contactId:"",
      customerId:"",
      contactTypeId:"",
      expand: false,
      basicInformation: false,
      showDocuments: false,
      contactTypes: [],
      contactsList: [],
      customerDocuments:[],
      assignContactType: false,
      showContacts: false,
      associateContactDialog: false,
      searchContacts: false,
      customerContacts: [],
      contactResult: [],
      organisations: [],
      errors: {
        contact: ""
      },
      search: "",
      dialog: false,
      newDialog: false,
      pagination: {},
      fnoContactSearchHeaders: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Surname",
          align: "center",
          value: "surname"
        },
        {
          text: "ID Number",
          align: "center",
          value: "idNumber"
        },
        {
          text: "Mobile Number",
          align: "center",
          value: "mobileNumber"
        },
        {
          text: "Permission Level",
          align: "center",
          value: "permissions"
        }
      ],
      contactSearchHeaders: [
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Permission Level",
          align: "center",
          value: "permissionLevel"
        },
        {
          text: "Select Contact Type",
          align: "center",
          value: "contactType"
        }
      ],
      contactsHeaders: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        // {
        //   text: "Contact Type",
        //   align: "center",
        //   value: "contactType"
        // },
        {
          text: "Mobile Number",
          align: "center",
          value: "mobileNumber"
        },
        {
          text: "Email Address",
          align: "center",
          value: "emailAddress"
        }
      ],
      headers: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Xero Code",
          align: "center",
          value: "xeroCode"
        },
        {
          text: "Customer Type",
          align: "center",
          value: "customerType.name"
        },
        //  {
        //   text: "Sales Email Address",
        //   align: "center",
        //   value: "salesEmailAddress"
        // },
        {
          text: "Active",
          align: "center",
          value: "isActive"
        }
      ],
      customerType: [],
      customers: [],
      editedIndex: -1,
      editedItem: {
        id: "",
        idNumber: "",
        name: "",
        xeroCode: "",
        termsConditionsLink: "",
        salesEmailAddress: "",
        logo: "",
        contactType: "",
        contactTypeId: "",
        customerType: null,
        customerTypeId: null,
        primaryColour: {r: 0, g: 0, b:0},
        secondaryColour: {r: 0, g: 0, b:0},
        isActive: true,
        isDeleted: false,

        customerOrganisationId: null,

        customerId: null,
        regNo: "",
        vatNo: "",
        ispTermsConditionsLink: null,
        fupUrl: "",
        applicationsEmailAddress: "",
        layer3Rate: null,
        layer2Rate: null,
        layer2Usage: null,
        layer2Percentage: null,
        librePortId: null,
        bankName: "",
        bankBranchCode: "",
        bankAccountType: "",
        bankAccountNumber: "",
        billableCustomerId: null,
        isDeleted: false,
        isActive: true
      },
      defaultItem: {
        name: "",
        xeroCode: "",
        ispTermsConditionsLink: null,
        logo: "",
        salesEmailAddress: "",
        contactType: "",
        contactTypeId: "",
        customerType: null,
        customerTypeId: null,
        isActive: true,
        isDeleted: false,

        customerOrganisationId: null,

        customerId: null,
        regNo: "",
        vatNo: "",
        ispTermsConditionsLink: null,
        fupUrl: "",
        applicationsEmailAddress: "",
        layer3Rate: null,
        layer2Rate: null,
        layer2Usage: null,
        layer2Percentage: null,
        librePortId: null,
        bankName: "",
        bankBranchCode: "",
        bankAccountType: "",
        bankAccountNumber: "",
        billableCustomerId: null,
        isDeleted: false,
        isActive: true
      },
     
    };
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    // contactSearch(value) {
    //   this.isLoading =true
    //   if (value != "") {
    //     Api()
    //       .get("/contacts", {
    //         params: {
    //           search: value
    //         }
    //       })
    //       .then(response => {
    //         this.contactsList = response.data;
    //         this.isLoading =false
    //       });
    //   } else {
    //     Api()
    //       .get("/contacts")
    //       .then(response => {
    //         this.contactsList = response.data;
    //         this.isLoading =false
    //       });
    //   }
    // },
    search(value) {
      const route = {
        name: this.$route.name
      };
      if (this.search) {
        route.query = { search: this.search };
      }
      this.$router.push(route);
    },
    "$route.query": {
      immediate: true,
      async handler(value) {
        this.customers = await this.searchCustomers(value);
      }
    },
    "$route.query.search": {
      immediate: true,
      handler(value) {
        this.search = value;
      }
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    addCustomerContact(contactId, customerId){
      Api()
      .post('/customerContact', {
        contactId: contactId,
        customerId: customerId,
        isActive: true,
        isDeleted: false
      }).then(response=>{

      })
    },
    async convertCustomersToOrg(){
      for (let i=0;i< this.customers.length;i++){
        let type =null
        if(this.customers[i].customerType.name==='Internet Service Provider'){
          type = 4
        }
        else if(this.customers[i].customerType.name==='Body Corporate'){
          type = 2
        }
        else if(this.customers[i].customerType.name==='Home Owners Association'){
          type = 2
        }
        else if(this.customers[i].customerType.name==='Fibre Farmer Partner'){
          type = 5
        }
        else {
          type = 6
        }
        if(this.authenticateSystemAdmin(this.$store.state.user)){
            await Api()
            .post('/organisation',{
                name: this.customers[i].name,
                organisationTypeId: type,
                primaryColour: '#99cc33',
                secondaryColour: '#c2c7bd',
                navbarColour: '#7a7676',
                navbarTextColour: '#ffffff',
                primaryOrganisationId: 1,
                isActive: true,
                isDelete: false
            }).then(response=>{
              Api()
              .post('/userRole',{
                name: 'Admin',
                description: 'Default Admin Role',
                userGroupId: 4,
                isAdmin: true,
                organisationId: response.data.id,
                isActive: true,
                isDelete: false
              })
              this.generateOrganisationToken(response.data)
              Api()
              .put('/customers/'+this.customers[i].id,{
                customerOrganisationId: response.data.id
              })
          
      })}}
    },
    updateIspSettings(){
      for (let i=0;i<this.customers.length;i++){
        if(typeof this.customers[i]!=='undefined'&&this.customers[i].ispSettings.length>0){
          let settings=this.customers[i].ispSettings[0]
          Api()
          .put('/organisation/'+this.customers[i].customerOrganisationId,{
            vatNo: settings.vatNo,
            salesEmailAddress: settings.applicationsEmailAddress,
            termsAndConditionsLink: settings.isptermsConditionsLink,
            fupUrl: settings.fupUrl
          })
        }
      }
    },
    generateOrganisationToken(item){
      Api()
      .post('/orgToken',{
        id: item.id,
        name: item.name,
        description: item.description
      })
      .then(response=>{
        let token=response.data.token
        Api()
        .put('/organisation/'+item.id,{
          token: token
        })
      })
    },
    searchCustomers(search) {
      this.isLoading =true
      if (search.search !== "") {
        Api()
          .get("/customers", {
            params: {
              search: search.search
            }
          })
          .then(response => {
            this.customers = response.data;
            this.isLoading =false
          });
      }
    },
    fetchCustomers() {
      this.isLoading =true
      Api()
        .get("/customers")
        .then(response => {
          this.customers = response.data;
              this.isLoading =false
        });
    },
    fetchOrganisations() {
      this.isLoading =true
      Api()
        .get("/organisation/basic")
        .then(response => {
          this.organisations = response.data;
              this.isLoading =false
        });
    },
    fetchCustomerTypes() {
      Api()
        .get("/customerTypes/active")
        .then(response => {
          this.customerType = response.data;
        });
    },
    async fetchContacts(customerId) {
      await Api()
        .get("/customercontact/showByCustomer/" + customerId)
        .then(response => {
          this.customerContacts = response.data;
        });
    },
    findContactById(idNumber) {
      this.associateContactDialog = true;
      Api()
        .get("/contacts/byIdNumber/" + idNumber)
        .then(response => {
          this.contactResult = response.data;
          this.editedItem.contactTypeId =
            response.data[0].customerContacts[0].contactTypeId;
        });
    },
    fetchContactTypes() {
      Api()
        .get("/contactTypes")
        .then(response => {
          this.contactTypes = response.data;
        });
    },
    fetchContactsList() {
      Api()
        .get("/contacts")
        .then(response => {
          this.contactsList = response.data;
        });
    },
    getOrganisations(){
          Api()
          .get('/customer/organisation')
          .then(response=>{
              this.organisations=response.data
          })
      },
    initialize() {
      this.getOrganisations();
      this.fetchContactsList();
      this.fetchCustomers();
      this.fetchCustomerTypes();
      this.fetchContactTypes();
      this.fetchOrganisations()
    },
    fetchDocuments(){
      Api()
      .get('/upload/byCustomer/'+this.editedItem.id)
      .then(response=>{
        this.customerDocuments=response.data
      })
    },
    async editItem(item) {
      this.editedIndex = this.customers.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.customerId=item.id
      this.fetchDocuments();


      if(typeof(item.ispSettings) !== 'undefined'&&(item.ispSettings) !==null&&item.ispSettings.length>0){
           this.editedItem.customerId= item.ispSettings[0].customerId,
           this.editedItem.regNo= item.ispSettings[0].regNo,
           this.editedItem.vatNo= item.ispSettings[0].vatNo,
           this.editedItem.ispTermsConditionsLink= item.ispSettings[0].ispTermsConditionsLink,
           this.editedItem.fupUrl= item.ispSettings[0].fupUrl,
           this.editedItem.applicationsEmailAddress= item.ispSettings[0].applicationsEmailAddress,
           this.editedItem.layer3Rate=item.ispSettings[0].layer3Rate,
           this.editedItem.layer2Rate=item.ispSettings[0].layer2Rate,
          //  this.editedItem.layer2Usage= item.ispSettings[0].layer2Usage,
          //  this.editedItem.layer2Percentage= item.ispSettings[0].layer2Percentage,
           this.editedItem.librePortId= item.ispSettings[0].librePortId,
           this.editedItem.bankName= item.ispSettings[0].bankName,
           this.editedItem.bankBranchCode= item.ispSettings[0].bankBranchCode,
           this.editedItem.bankAccountType=item.ispSettings[0].bankAccountType,
           this.editedItem.bankAccountNumber=item.ispSettings[0].bankAccountNumber,
           this.editedItem.billableCustomerId=item.ispSettings[0].billableCustomerId,
           this.primaryColour=item.ispSettings[0].primaryColour,
           this.secondaryColour=item.ispSettings[0].secondaryColour,
           this.editedItem.isDeleted= item.ispSettings[0].isDeleted,
           this.editedItem.isActive= item.ispSettings[0].isActive
      } else {
        this.primaryColour='#a6aba8'
        this.secondaryColour='#a6aba8'
      }
      this.dialog = true;
    },
    deleteItem(id) {
      confirm("Are you sure you want to delete this item?") &&
        Api().put("/customers/" + id, {
          isActive: false,
          isDeleted: true
        }).then(response => {
          this.fetchCustomers();
        });     
    },
    async deleteContact(item){
      confirm("Are you sure you want to delete this item?") &&
        await Api().put("/customercontact/" + item.id, {
          isActive: false,
          isDeleted: true
        }).then(this.fetchContacts(item.customerId));
      ;
    },
    linkContact(contactId, customerId, contactTypeId) {
      if(contactTypeId!=null){
        Api()
        .get("/customercontact/"+customerId+'/' + contactId)
        .then(response => {
          if (!response.data[0]) {
            Api()
              .post("/customercontact", {
                customerId: customerId,
                contactId: contactId,
                contactTypeId: contactTypeId
              })
              .then(response => {
                Api()
                  .get("/customercontact/showByCustomer/" + customerId)
                  .then(response => {
                    this.customerContacts = response.data;
                  });
              });
            this.associateContactDialog = false;
            this.searchContacts = false;
            this.assignContactType=false;
          } else {
            this.errors.contact =
              "This Contact is already linked to this Customer";
          }
        });
      } else {
        this.errors.contact =
              "Please assign a contact type";
      }
      
    },
    close() {
      this.dialog = false;
      this.assignContactType=false;
      this.newDialog = false;
      this.showContacts = false;
      this.showDocuments=false;
      this.basicInformation = false;
      this.associateContactDialog = false;
      this.searchContacts = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async findContact() {
      if (this.contactSearch != "") {
        await Api()
          .get("/contacts", {
            params: {
              search: this.contactSearch
            }
          })
          .then(response => {
            this.contactsList = response.data;
          });
      } else {
        await Api()
          .get("/contacts")
          .then(response => {
            this.contactsList = response.data;
          });
      }
      this.searchContacts = true;
    },
    save() {
      let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
      if (proceed == true) {
        Api().put("/customers/" + this.editedItem.id, {
          name: this.editedItem.name,
          xeroCode: this.editedItem.xeroCode,
          termsConditionsLink: this.editedItem.termsConditionsLink,
          salesEmailAddress: this.editedItem.salesEmailAddress,
          logo: this.editedItem.logo,
          customerOrganisationId: this.editedItem.customerOrganisationId,
          customerTypeId: this.editedItem.customerTypeId,
          isDeleted: this.editedItem.isDeleted,
          isActive: this.editedItem.isActive
        });
        this.$emit("customersSaved");
        this.close();
        this.fetchCustomers();
      }  
      if(this.editedItem.customerType.name == "Internet Service Provider"){          
            if(this.editedItem.ispSettings.length>0){
              
           Api().put("/ispSettings/" + this.editedItem.ispSettings[0].id, {
           customerId: this.editedItem.id,
           regNo: this.editedItem.regNo,
           vatNo: this.editedItem.vatNo,
           ispTermsConditionsLink: this.editedItem.ispTermsConditionsLink,
           fupUrl: this.editedItem.fupUrl,
           applicationsEmailAddress: this.editedItem.applicationsEmailAddress,
           layer3Rate:this.editedItem.layer3Rate,
           layer2Rate:this.editedItem.layer2Rate,
          //  layer2Usage: this.editedItem.layer2Usage,
          //  layer2Percentage: this.editedItem.layer2Percentage,
           librePortId: this.editedItem.librePortId,
           bankName: this.editedItem.bankName,
           bankBranchCode: this.editedItem.bankBranchCode,
           bankAccountType: this.editedItem.bankAccountType,
           bankAccountNumber: this.editedItem.bankAccountNumber,
           billableCustomerId: this.editedItem.billableCustomerId,
           primaryColour: this.primaryColour.hex,
           secondaryColour: this.secondaryColour.hex,
           isDeleted: this.editedItem.isDeleted,
           isActive: this.editedItem.isActive
        });}else{
          Api().post("/ispSettings", {
           customerId: this.editedItem.id,
           regNo: this.editedItem.regNo,
           vatNo: this.editedItem.vatNo,
           ispTermsConditionsLink: this.editedItem.ispTermsConditionsLink,
           fupUrl: this.editedItem.fupUrl,
           applicationsEmailAddress: this.editedItem.applicationsEmailAddress,
           layer3Rate:this.editedItem.layer3Rate,
           layer2Rate:this.editedItem.layer2Rate,
          //  layer2Usage: this.editedItem.layer2Usage,
          //  layer2Percentage: this.editedItem.layer2Percentage,
           librePortId: this.editedItem.librePortId,
           bankName: this.editedItem.bankName,
           bankBranchCode: this.editedItem.bankBranchCode,
           bankAccountType: this.editedItem.bankAccountType,
           bankAccountNumber: this.editedItem.bankAccountNumber,
           billableCustomerId: this.editedItem.billableCustomerId,
           isDeleted: this.editedItem.isDeleted,
           isActive: this.editedItem.isActive
        });
              }
          this.fetchCustomers();
       }
    },
     checkIsp(){   
       if(typeof this.editedItem.customerType!=='undefined'&&this.editedItem.customerType!==null&&this.editedItem.customerType.name == "Internet Service Provider"){ 
            this.ispFlag=true
       }else {
             this.ispFlag=false
            this.ispTab=false
       }
     },
    saveNew() {
      let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
      if (proceed == true) {
        Api()
          .post("/customers", {
            name: this.editedItem.name,
            xeroCode: this.editedItem.xeroCode,
            termsConditionsLink: this.editedItem.termsConditionsLink,
            salesEmailAddress: this.editedItem.salesEmailAddress,
            logo: this.editedItem.logo,
            customerTypeId: this.editedItem.customerTypeId,
            customerOrganisationId: this.editedItem.customerOrganisationId,
            isDeleted: this.editedItem.isDeleted,
            isActive: this.editedItem.isActive
          })
          .then(response => {
            this.fetchCustomers();
          });
        this.$emit("customersSaved");
        this.close();
      }
    }
  }
};
</script>
